import { TypedDocumentNode } from '@apollo/client';
import { useLazyQuery, useReactiveVar } from '@apollo/client/react';
import { Query, QueryGetVisitorGroupsForTenantArgs } from 'graphql/generated/graphqlTypes';
import { GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS } from 'graphql/queries';
import { useEffect } from 'react';
import { setVisitorGroupsMembersAction } from 'state/actions/visitorGroupsMembers';
import { visitorsGroupsMembersVar } from 'state/vars';
import { BaseHookProps } from '../shared/types';

// Typing the documents (instead of passing generics to the Apollo hooks) avoids the deprecated hook signatures.
const GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS_TYPED: TypedDocumentNode<
  Pick<Query, 'getVisitorGroupsForTenant'>,
  QueryGetVisitorGroupsForTenantArgs
> = GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS;

const useVisitorsGroupsMembers = ({ handleFetchError }: BaseHookProps) => {
  const visitorsGroupsMembers = useReactiveVar(visitorsGroupsMembersVar);

  const [getVisitorsGroupsMembers, { loading }] = useLazyQuery(GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS_TYPED);

  useEffect(() => {
    const fetchVisitorsGroupsMembers = async () => {
      try {
        const { data } = await getVisitorsGroupsMembers();
        if (data) {
          setVisitorGroupsMembersAction(data.getVisitorGroupsForTenant);
        }
      } catch {
        handleFetchError('Error while fetching visitor groups');
      }
    };
    void fetchVisitorsGroupsMembers();
  }, [getVisitorsGroupsMembers]);

  return {
    visitorsGroupsMembers,
    loading
  };
};

export default useVisitorsGroupsMembers;
